<template>
  <div class="boxLocalOcorrencia">
    <div v-if="!Object.entries(localData.localOcorrencia).length && !addModal"
         class="addButton">
      <button class="btn btn-sm btn-outline-primary btn-block mb-3 btn-add-local"
              :disabled="addModal"
              @click="[addModal = true, showModalLocalOcorrencia() ]">
        <icon-svg icon="add"
                  class="icon-add mr-1" />
        Adicionar local de ocorrência
      </button>
    </div>
    <div v-if="addModal"
         class="card p-2 mb-2">
      <div v-if="exibirSelect">
        <div class="row">
          <div class="col-sm-6 col-md-4">
            <div class="form-group">
              <div v-if="tipo && tipo !== 'HOSPITAL' && !flagExteriorDisabled">
                <span class="custom-control custom-switch mr-4 mb-4 mt-2">
                  <input :id="'flagExterior'"
                         v-model="exterior"
                         class="custom-control-input"
                         type="checkbox"
                         :value="1"
                         @change="setExterior">
                  <label class="custom-control-label"
                         :for="'flagExterior'">Óbito Fora do Brasil</label>
                </span>
              </div>

              <label class="label"
                     :class="{'label-error': propCorrecoes['LOCAL DE OCORRÊNCIA']}"
                     for="local_ocorrencia_id">
                Local da Ocorrência de Óbito
                <span v-if="propCorrecoes['LOCAL DE OCORRÊNCIA']">
                  <IconSvg class="icon-error-campo"
                           icon="alert" />
                </span>
              </label>

              <select id="local_ocorrencia_id"
                      ref="local_ocorrencia_id"
                      v-model="tipo"
                      :class="{ 'is-invalid': errors.has('local_ocorrencia_id') || propCorrecoes['LOCAL DE OCORRÊNCIA']}"
                      class="custom-select custom-select-sm"
                      name="local_ocorrencia_id"
                      @change="changeTipo">
                <option selected
                        :value="null">
                  Selecione
                </option>
                <option v-for="(local, index) in selectsOptions.locais_obito"
                        :key="index"
                        :value="local.val">
                  {{ local.name }}
                </option>
              </select>

              <small v-if="errors.has('local_ocorrencia_id')"
                     class="invalid-feedback">{{ errors.first('local_ocorrencia_id') }}</small>
              <small v-else-if="propCorrecoes['LOCAL DE OCORRÊNCIA']"
                     class="invalid-feedback">Campo incorreto</small>
            </div>
          </div>

          <div v-if="localData.localOcorrencia.tipo === 'HOSPITAL' && show_results"
               class="col-8 col-sm-auto col-md-8">
            <div class="form-group">
              <label class="label"
                     for="descricao">Nome do Estabelecimento</label>
              <input id="descricao"
                     v-model="nomeEstabelecimento"
                     class="form-control form-control-sm"
                     name="descricao"
                     placeholder="Hospital das Clínicas"
                     type="text"
                     @keyup.enter="search">
            </div>
          </div>
        </div>

        <div v-if="localData.localOcorrencia.tipo === 'HOSPITAL' && show_results"
             class="row mb-2">
          <div class="col-3">
            <div class="form-group">
              <label class="label"
                     :for="`uf-${_uid}`">UF</label>

              <v-select :id="`uf-${_uid}`"
                        v-model="uf"
                        class="form-control form-control-sm"
                        name="estado"
                        placeholder="Selecione"
                        :options="selectsOptions.states.map((state)=>state.uf)"
                        @input="ufChanged" />
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label class="label"
                     :for="`cidade-${_uid}`">Cidade</label>
              <v-select :id="`cidade-${_uid}`"
                        v-model="cidade"
                        name="cidade"
                        class="form-control form-control-sm"
                        placeholder="Selecione"
                        :options="selectsOptions.cities.map((city)=>city.nome)"
                        @input="cityChanged" />
            </div>
          </div>
          <div class="col-sm-auto align-self-center mt-1">
            <button class="btn btn-block btn-primary btn-sm"
                    type="button"
                    @click="search">
              Pesquisar Estabelecimento
            </button>
          </div>
        </div>
      </div>

      <div v-if="showHospitais && show_results">
        <div v-if="hospitais.length"
             class="pb-3">
          <p class="modal_title d-inline-block">
            Escolha o estabelecimento:
          </p>

          <div class="form-group">
            <span v-for="(hospital, index) in hospitais.filter((hospital) => hospital.endereco)"
                  :key="`${hospital.hospital_id}-${index}`"
                  class="custom-control custom-radio itensListagemEstabs">
              <input :id="`hospital-${hospital.hospital_id}`"
                     v-model="localOcorrenciaSelected"
                     :value="hospital"
                     type="radio"
                     :name="`hospitalSelecionada-${index}`"
                     class="custom-control-input"
                     @keyup.enter="localOcorrenciaSelected = hospital">
              <label class="custom-control-label"
                     :for="`hospital-${hospital.hospital_id}`">
                {{ hospital.nome }} - {{ hospital | Endereco }}
              </label>
            </span>
          </div>

          <Pagination :page="page"
                      :last-page="last_page"
                      @onPreviousPage="changePage(page - 1)"
                      @onNextPage="changePage(page + 1)" />
        </div>

        <p v-else
           class="noResults mt-3">
          Nenhum estabelecimento encontrado para essa busca.
        </p>

        <button class="btn btn-sm btn-outline-primary"
                type="button"
                @click="newHospital">
          Adicionar Novo
        </button>
      </div>

      <div v-if="!show_results && localData.localOcorrencia.tipo === 'HOSPITAL'">
        <form @submit.prevent="addHospital">
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label class="label"
                       for="nomeHospital">Nome do estabelecimento</label>
                <div class="d-flex justify-content-between align-items-center">
                  <input id="nomeHospital"
                         v-model="localOcorrenciaSelected.descricao"
                         v-validate="'required'"
                         :class="{ 'is-invalid': errors.has('nomeHospital'), 'hospital-edit': hospitais.length && edit}"
                         class="form-control form-control-sm"
                         name="nomeHospital"
                         placeholder="Hospital Último Suspiro"
                         required
                         type="text"
                         @change="changeNomeEstabelecimento">
                  <IconSvg v-if="edit"
                           class="hospital-edit-icon"
                           icon="alert" />
                </div>

                <small v-if="errors.has('nomeHospital')"
                       class="invalid-feedback">{{ errors.first('nomeHospital') }}</small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-5 col-md-3 col-lg-2">
              <div class="form-group">
                <label class="label"
                       for="telHospital">Telefone</label>
                <input id="telHospital"
                       v-model="localOcorrenciaSelected.telefone"
                       v-mask="'(##)#####-####'"
                       class="form-control form-control-sm"
                       :disabled="localOcorrenciaSelected.tipo ? !localOcorrenciaSelected.tipo.match('[H|h]ospital') : false"
                       maxlength="14"
                       name="telHospital"
                       placeholder="(00)00000-0000"
                       type="text">
              </div>
            </div>

            <div class="col-12 col-sm-5 col-md-3">
              <div class="form-group">
                <label class="label"
                       for="mailHospital">E-mail</label>
                <input id="mailHospital"
                       v-model="localOcorrenciaSelected.email"
                       v-validate="'email'"
                       :class="{ 'is-invalid': errors.has('mailHospital') }"
                       :disabled="localOcorrenciaSelected.tipo ? !localOcorrenciaSelected.tipo.match('[H|h]ospital') : false"
                       class="form-control form-control-sm"
                       name="mailHospital"
                       placeholder="email@email.com.br"
                       type="email">
                <small v-if="errors.has('mailHospital')"
                       class="invalid-feedback">{{ errors.first('mailHospital') }}</small>
              </div>
            </div>

            <div class="col-12 col-sm-3 align-self-end mb-1">
              <div class="form-group">
                <div class="custom-control custom-switch">
                  <input id="hospAtivo"
                         v-model="localOcorrenciaSelected.ativo"
                         :disabled="localOcorrenciaSelected.tipo ? !localOcorrenciaSelected.tipo.match('[H|h]ospital') : false"
                         class="custom-control-input"
                         name="hospAtivo"
                         type="checkbox">
                  <label class="custom-control-label"
                         for="hospAtivo">Ativo</label>
                </div>
              </div>
            </div>
          </div>
        </form>
        <LocalOcorrenciaSugestao v-if="hospitais.length > 1"
                                 :prop-lista-hospitais="hospitais"
                                 @changeHospital="changeHospital" />
        <BoxEndereco :data="localOcorrenciaSelected.endereco"
                     :prop-mostrar-exterior="false"
                     :exterior-disable="exterior"
                     @onEnderecoAdd="receiveAddress" />
      </div>

      <!-- ENDERECO DOS DEMAIS TIPOS -->
      <div v-if="exibirEndereco">
        <p v-if="results.data && results.total === 0"
           class="mb-0">
          <small><strong>Nenhum resultado encontrado.</strong>
            <br> Talvez este local não esteja cadastrado ainda no nosso banco de dados ou você esteja sem conexão com a internet. Mas você pode preencher o endereço manualmente abaixo.</small>
        </p>

        <small v-if="checkAdressOcorrencia"
               class="text-danger">
          Caso não saiba o local do óbito, informe Estado e Cidade onde o óbito foi identificado como referência.
        </small>

        <BoxEndereco :prop-mostrar-exterior="false"
                     :no-header="true"
                     :data="localData.localOcorrencia.endereco"
                     :exterior-disable="exterior"
                     @onEnderecoAdd="getLocalOcorrenciaEndereco" />
      </div>

      <hr>

      <div class="row">
        <div class="col-12 d-inline-flex justify-content-end">
          <button class="btn btn-sm btn-dark mr-2"
                  type="button"
                  @click="voltar()">
            Voltar
          </button>
          <button v-if="addButton"
                  class="btn btn-sm btn-primary"
                  type="button"
                  :disabled="!localData.localOcorrencia.tipo || (tipo === 'HOSPITAL' && Object.entries(localOcorrenciaSelected).length === 0)"
                  @click="adicionar()">
            Adicionar
          </button>
          <button v-else
                  class="btn btn-sm btn-primary"
                  type="button"
                  :disabled="!localData.localOcorrencia.tipo"
                  @click="editar()">
            Editar
          </button>
        </div>
      </div>
    </div>
    
    <!-- BOX HOSPITAL -->
    <div v-if="!addModal && Object.entries(localData.localOcorrencia).length">
      <BoxLocalOcorrencia :dados="localData.localOcorrencia"
                          :prop-correcoes="propCorrecoes">
        <slot>
          <button type="button"
                  class="btn btn-sm btn-danger mr-2"
                  @click="removeLocalOcorrencia">
            Remover
          </button>

          <button class="btn btn-sm btn-primary"
                  type="button"
                  @click="editLocalOcorrencia">
            Editar
          </button>
        </slot>
      </BoxLocalOcorrencia>
    </div>
  </div>
</template>

<script>
  /* components */
  import BoxEndereco from '@/components/SofiaRei/BoxEndereco.vue'
  import BoxLocalOcorrencia from '@/components/SofiaRei/Nascimento/BoxLocalOcorrencia'
  import Pagination from "@/components/SofiaRei/Pagination"
  import LocalOcorrenciaSugestao from '@/components/SofiaRei/Obito/Passos/Sessoes/LocalOcorrenciaSugestao'
  import Swal from 'sweetalert2'

  /* services */
  import EnderecosService from "@/services/Enderecos"
  import HospitaisService from "@/services/HospitaisService"

  /* constants */
  import BrazilianStates from "@/constants/brazilianStates"
  import objSwal from '@/constants/swalValues'
  import { locaisObito } from '@/constants/locaisObito'
  import { CADASTRAR_LOCAL_OBITO, ADMIN } from "@/constants/permissions"

  /* outros */
  import { mapGetters } from 'vuex'

  export default {
    name: 'LocalOcorrencia',
    components: { BoxEndereco, BoxLocalOcorrencia, Pagination, LocalOcorrenciaSugestao },
    inject: ['$validator'],
    props: {
      enderecoFalecido: { type: Object, default: (() => {}) },
      localOcorrencia: { type: Object, default: () => { return {} } },
      readOnly: { type: Boolean, default: () => false},
      propValidator: { type: Boolean, default: () => false },
      propCartorio: { type: Object, default: () => { return {} } },
      propCorrecoes: {type: Object, default: () => ({})},
    },
    data () {
      return {
        tipo: null,
        results: [],
        hospitais: [],
        nomeEstabelecimento: '',
        localOcorrenciaSelected: {},
        localData: { localOcorrencia: {} },
        selectsOptions: {
          locais_obito: locaisObito,
          states: [...BrazilianStates],
          cities: []
        },
        flagExteriorDisabled: true,
        addModal: false,
        addButton: true,
        uf: null,
        cidade: null,
        show_results: true,
        showHospitais: false,
        page: 1,
        last_page: 1,
        edit: false,
        exterior: false,
        CADASTRAR_LOCAL_OBITO,
        ADMIN
      }
    },
    computed: {
      checkAdressOcorrencia () {
        let check = false
        let { endereco } = this.localData && this.localData.localOcorrencia ? this.localData.localOcorrencia : { endereco: {} }

        if (!endereco) {
          check = true
        } else {
          if (!endereco.exterior && (!endereco.cidade || !endereco.uf)) { check = true }
          if (endereco.exterior && !endereco.logradouro) { check = true }
        }

        return check
      },
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        user: 'auth/getUser'
      }),
      exibirSelect () {
        const { localOcorrencia: {hospital_id, local_ocorrencia_id, tipo, descricao}} = this.localData

        if ((hospital_id || local_ocorrencia_id) && tipo == 'HOSPITAL' && descricao) return false
        else return true
      },

      exibirEndereco () {
        const { localOcorrencia: { tipo }} = this.localData
        if (tipo && tipo != 'IGNORADO' && tipo != 'HOSPITAL' || (this.tipo && this.tipo != 'IGNORADO' && this.tipo != 'HOSPITAL')) return true
        return false
      }
    },
    watch: {
      localOcorrencia () {
        this.init()
      },
      addModal () {
        if (!this.edit) {
          this.exterior = false
        }

        if (this.edit && this.localData.localOcorrencia.endereco.codigo_pais) {
          this.exterior = true
        }
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      modalChanged () {
        this.show_results = true
        this.localOcorrenciaSelected = {},
        this.edit = false
      },
      modalChangedHide () {
        this.addModal = false
        this.localData.localOcorrencia = this.localOcorrencia
        this.hospitais = []
        this.results = []
        this.showHospitais = false
        this.addButton = true

        if (!this.edit) {
          this.tipo = null
        }

        this.modalChanged()
        this.changed()
      },
      init () {
        if (this.localOcorrencia && Object.entries(this.localOcorrencia).length > 0) {
          this.localData.localOcorrencia = { ...this.localOcorrencia }

          const { hospital, ativo, tipo } = this.localOcorrencia

          this.localData.localOcorrencia.ativo = hospital ? hospital.ativo : ativo
          this.tipo = tipo

          if (hospital) {
            this.localData.localOcorrencia = {
              ...this.localData.localOcorrencia,
              email: hospital.email,
              telefone: hospital.telefone
            }
          }
        }

        this.tipo = null
        this.addModal = false
        this.showHospitais = false
      },
      showModalLocalOcorrencia () {
        setTimeout(() => {
          this.$refs.local_ocorrencia_id.focus()
        }, 50)
      },
      adicionar () {
        if (this.localData.localOcorrencia.tipo === 'HOSPITAL') {
          this.show_results ? this.setHospital() : this.addHospital()
        } else {
          this.$validator.validateAll().then((resp) => {
            if (!resp) return
            this.changed()
            this.addModal = false
          })
        }
      },
      editar () {
        if (this.localData.localOcorrencia.tipo === 'HOSPITAL') {
          this.editarHospital()
        } else {
          this.$validator.validateAll().then((resp) => {
            if (!resp) return
            this.changed()
            this.addModal = false
          })
        }
      },
      voltar () {
        if (this.tipo === 'HOSPITAL' && !this.show_results && !this.edit) {
          this.show_results = true
          this.localOcorrenciaSelected = {}
          return
        }

        if (!this.edit) {
          this.localData.localOcorrencia = {}
        }

        this.init()
      },
      setExterior () {
        if (this.exterior) {
          this.localData.localOcorrencia.endereco = {
            ...this.localData.localOcorrencia.endereco,
            exterior: this.exterior,
            uf: null,
            cidade: null
          }
        } else {
          this.localData.localOcorrencia.endereco = {
            ...this.localData.localOcorrencia.endereco,
            logradouro: null,
            uf: this.enderecoFalecido.uf,
            cidade: this.enderecoFalecido.cidade
          }

          delete this.localData.localOcorrencia.endereco.codigo_pais
          delete this.localData.localOcorrencia.endereco.pais
        }
      },
      async setHospital () {
        if (!Object.values(this.localOcorrenciaSelected).length || (!this.localOcorrenciaSelected.descricao && !this.localOcorrenciaSelected.nome)) {
          objSwal.error.title = "Erro!"
          objSwal.error.text = "Não foi encontrado nenhum hospital selecionado."

          return Swal.fire(objSwal.error)
        }

        this.localData.localOcorrencia = {
          ...this.localOcorrenciaSelected,
          tipo: 'HOSPITAL',
          endereco: {...this.localOcorrenciaSelected.endereco, endereco_id: null},
          hospital_id: this.localOcorrenciaSelected.hospital_id,
          descricao: this.localOcorrenciaSelected.nome,
          endereco_id: null
        }

        this.hospitais = []
        this.addModal = false

        this.changed()
      },
      async search () {
        try {
          loader({ active: true })

          this.results = await HospitaisService.getHospitais({
            cartorio_id: this.$store.state.auth.cartorio_id,
            nome: this.nomeEstabelecimento,
            ativo: 1
          })

          this.hospitais = this.results.data
          this.showHospitais = true
          this.show_results = true
          this.last_page = this.results.lastPage
          this.localOcorrenciaSelected = {}

        } catch (error) {
          this.displayError('Não foi possível buscar o hospital, tente novamente!', '')
        } finally {
          loader({ active: false })
        }
      },
      changeTipo () {
        this.show_results = true
        this.showHospitais = false
        this.results = []

        this.localData.localOcorrencia = {
          tipo: this.tipo,
          descricao: locaisObito.find((local) => local.val === this.tipo).name
        }

        if (this.propCartorio && this.propCartorio.endereco && this.tipo != 'IGNORADO') {
          this.localData.localOcorrencia.endereco = {
            uf: this.propCartorio.endereco.uf,
            cidade: this.propCartorio.endereco.cidade,
            ibge: this.propCartorio.endereco.ibge
          }
        } else {
          this.localData.localOcorrencia.endereco = {}
        }

        this.localOcorrenciaSelected = {}

        if (!this.tipo) {
          this.tipo = null
          return
        }

        if (this.tipo === 'DOMICILIO') {
          this.hospitais = []

          this.localData.localOcorrencia = Object.assign({}, this.localData.localOcorrencia, {
            ...this.localData.localOcorrencia,
            endereco: this.enderecoFalecido
          })
        }
      },
      getLocalOcorrenciaEndereco (endereco) {
        this.localData.localOcorrencia.endereco = endereco
      },
      changed () {
        this.deleteError(['LOCAL DE OCORRÊNCIA'])
        this.$emit('changed', this.localData)
      },
      async ufChanged (uf) {
        if (!uf) {
          this.cidade = null
          return
        }

        try {
          loader({ active: true })
          this.results = await HospitaisService.getHospitais({
            cartorio_id: this.$store.state.auth.cartorio_id,
            nome: this.nomeEstabelecimento,
            uf: this.uf,
            ativo: 1
          })

          this.page = 1
          this.last_page = this.results.lastPage
          this.hospitais = this.results.data
          this.showHospitais = true

        } catch (error) {
          this.displayError('Não foi possível buscar o hospital, tente novamente!', '')
        }

        for (let state of this.selectsOptions.states) {
          if (state.uf == uf) {
            this.uf = state.uf
            this.cidade = null

            this.selectsOptions.cities = await EnderecosService.getCitiesByState(state.uf)
            break
          }
        }

        loader({ active: false })
      },
      async cityChanged () {
        if (!this.cidade) return

        try {
          loader({ active: true })
          this.results = await HospitaisService.getHospitais({
            cartorio_id: this.$store.state.auth.cartorio_id,
            nome: this.nomeEstabelecimento,
            cidade: this.cidade,
            ativo: 1
          })

          this.page = 1
          this.last_page = this.results.lastPage
          this.hospitais = this.results.data
          this.showHospitais = true

        } catch (error) {
          this.displayError('Não foi possível buscar o hospital, tente novamente!', '')
        }

        loader({ active: false })
      },
      receiveAddress (endereco) {
        this.localOcorrenciaSelected.endereco = endereco
      },
      addHospital () {
        if (!Object.values(this.localOcorrenciaSelected).length || (!this.localOcorrenciaSelected.descricao && !this.localOcorrenciaSelected.nome)) {
          objSwal.error.title = "Erro!"
          objSwal.error.text = "Nome do hospital obrigatório."

          return Swal.fire(objSwal.error)
        }

        let objEnvio = {
          ...this.localOcorrenciaSelected,
          nome: this.localOcorrenciaSelected.descricao,
          cartorio_id: this.$store.state.auth.cartorio_id
        }

        this.$validator.validateAll().then(async (resp) => {
          if (!resp) return
          try {
            loader({ text: 'Cadastrando hospital...', active: true })

            const hospital = await HospitaisService.saveHospitais(objEnvio)

            this.localData.localOcorrencia = {
              ...this.localOcorrenciaSelected,
              tipo: this.tipo,
              hospital_id: hospital.hospital_id,
              endereco: {...this.localOcorrenciaSelected.endereco, endereco_id: null},
              endereco_id: null
            }

            this.addModal = false
            this.show_results = true
            this.changed()
          } catch (error) {
            const message = getErrors(error)

            return displayMessage('error', 'Erro ao cadastrar hospital!', message.message)
          } finally {
            this.hospitais = []
            loader({ text: '', active: false })
          }
        })
        return
      },
      removeLocalOcorrencia () {
        objSwal.question.title = 'Tem certeza que deseja excluir esse local de ocorrência?'
        objSwal.question.text = ''
        objSwal.question.cancelButtonText = 'Não'
        objSwal.question.confirmButtonText = 'Sim'

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        Swal.fire(objSwal.question).then(resp => {
          if (resp.value) {
            this.localData.localOcorrencia = {}
            this.tipo = null
            this.addModal = false
            this.changed()
          }
        })
      },
      async changeNomeEstabelecimento () {
        this.localData.localOcorrencia.descricao = this.localOcorrenciaSelected.descricao

        if (this.tipo === 'HOSPITAL') {
          try {
            loader({ active: true })

            this.results = await HospitaisService.getHospitais({
              cartorio_id: this.$store.state.auth.cartorio_id,
              nome: this.localOcorrenciaSelected.descricao,
              ativo: 1
            })

            this.hospitais = this.results.data
          } catch (error) {
            this.displayError('Não foi possível buscar o hospital, tente novamente!', '')
          } finally {
            loader({ active: false })
          }
        }
      },
      async editLocalOcorrencia () {
        if (this.localData.localOcorrencia.hospital_id) {
          this.localData.localOcorrencia = {
            ...this.localData.localOcorrencia,
            tipo: 'HOSPITAL',
            descricao: this.localData.localOcorrencia.nome
          }
        }

        if (this.tipo !== 'HOSPITAL') {
          this.localData.localOcorrencia.endereco = {
            ...this.localData.localOcorrencia.endereco,
            exterior: this.exterior
          }
        }

        this.localOcorrenciaSelected = {...this.localData.localOcorrencia}
        this.show_results = false
        this.edit = true
        this.addModal = true
        this.addButton = false

        try {
          loader({ active: true })

          this.results = await HospitaisService.getHospitais({
            cartorio_id: this.$store.state.auth.cartorio_id,
            nome: this.localOcorrenciaSelected.descricao,
            ativo: 1
          })

          this.hospitais = this.results.data

        } catch (error) {
          console.error(error)
        } finally {
          loader({ active: false })
        }
      },
      changeHospital (hospital) {
        if (hospital) {
          this.localOcorrenciaSelected = {
            ...hospital,
            tipo: 'HOSPITAL',
            endereco: {...hospital.endereco, endereco_id: null},
            hospital_id: hospital.hospital_id,
            descricao: hospital.nome,
            endereco_id: null
          }
        } else {
          this.localOcorrenciaSelected = {...this.localData.localOcorrencia}
        }
      },
      displayError (title, text) {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = ''

        return Swal.fire(objSwal.error)
      },

      editarHospital () {
        //Não atualizamos hospital cadastrado, apenas o loca de ocorrencia
        this.localData.localOcorrencia = {...this.localOcorrenciaSelected}
        this.localOcorrenciaSelected = {}
        this.addModal = false
        this.show_results = true
        this.changed()
        return

        //Para atualizar hospital
        if (!Object.values(this.localOcorrenciaSelected).length || (!this.localOcorrenciaSelected.descricao && !this.localOcorrenciaSelected.nome)) {
          objSwal.error.title = "Erro!"
          objSwal.error.text = "Nome do hospital obrigatório."

          return Swal.fire(objSwal.error)
        }

        let objEnvio = {
          ...this.localOcorrenciaSelected,
          nome: this.localOcorrenciaSelected.descricao,
          cartorio_id: this.$store.state.auth.cartorio_id
        }

        this.$validator.validateAll().then(async (resp) => {
          if (!resp) { return }

          loader({ text: 'Atualizando local de ocorrência...', active: true })

          const {localOcorrencia: {hospital, hospital_id}} = this.localData

          const id = hospital ? hospital.hospital_id : hospital_id

          try {
            await HospitaisService.updateHospitais(objEnvio, id)

            this.localData.localOcorrencia = this.localOcorrenciaSelected
            this.changed()
          } catch ({response}) {
            this.displayError('Não foi possível editar o hospital, tente novamente!', '')
          } finally {
            this.localOcorrenciaSelected = {}
            loader({ text: '', active: false })
          }
        })

        return
      },
      async changePage (page) {
        this.results = await HospitaisService.getHospitais({
          cartorio_id: this.$store.state.auth.cartorio_id,
          nome: this.nomeEstabelecimento,
          page: page,
          ativo: 1
        })

        this.page = page
        this.last_page = this.results.lastPage
        this.hospitais = this.results.data
      },
      newHospital () {
        // Verificamos a permissão no método pois nenhuma rota é chamada
        // Se for oficial ou suporte não validamos
        const { groups, flag_oficial } = this.user

        let login = ''

        if (this.user) {
          login = this.user.login.split('_')[0]
        }

        if (groups && groups.length && !flag_oficial) {
          let access = false
          const permissions = [this.CADASTRAR_LOCAL_OBITO, this.ADMIN]

          groups.forEach(group => {
            const permission = !!group.permissions.find(permission => !!permissions.includes(permission.codename))

            if (permission && group.ativo) access = true
          })

          if (!access) {
            return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
          }
        } else if (login !== 'suporte' && !flag_oficial) {
          return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
        }

        this.localOcorrenciaSelected = {
          ativo: 1,
          descricao: this.nomeEstabelecimento
        }

        if (this.propCartorio && this.propCartorio.endereco) {
          this.localOcorrenciaSelected.endereco = {
            uf: this.propCartorio.endereco.uf,
            cidade: this.propCartorio.endereco.cidade,
            ibge: this.propCartorio.endereco.ibge
          }
        } else {
          this.localOcorrenciaSelected.endereco = {}
        }

        this.show_results = false
      },
      deleteError (error) {
        this.$emit('deleteError', error)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .itensListagemEstabs {
    margin-left: 1rem;
  }

  .noResults {
    font-size: pxToRem(18);
    font-weight: 500;
    text-align: center;
  }

  .modal {
    &_title {
      font-size: 20px;
    }
  }

  .hospital-edit {
    border-color: #7f7e26;

    &-icon {
      width: 24px;
      height: 24px;
      fill: #7f7e26;
      margin-left: 16px;
    }
  }

  .btn-add-local:hover > [class*=icon-add] {
    fill: #fff !important;
  }
  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
</style>
